// src/components/constants/meses.ts

export const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
] as const;

// Por si necesitas tipos:
export type MesNombre = (typeof MESES)[number];
